import React from 'react';

const TagsIcon = class extends React.Component {
	render() {
		return (
			<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style={this.props.style||{}}>
				<path d="M30.04163,18.55615,21.55634,27.0415a.99978.99978,0,0,1-1.41419,0L19.0661,25.83325,26.19226,18.707a.99986.99986,0,0,0,0-1.41406L14.90027,5H18.4599a.99985.99985,0,0,1,.73676.32385l10.845,11.81824A.99986.99986,0,0,1,30.04163,18.55615Zm-7,0L14.55634,27.0415a1.00023,1.00023,0,0,1-1.41419,0L2.26318,15.18628A1.0004,1.0004,0,0,1,2,14.51013V6A1,1,0,0,1,3,5h8.4599a.99985.99985,0,0,1,.73676.32385l10.845,11.81824A.99986.99986,0,0,1,23.04163,18.55615ZM10,11a2,2,0,1,0-2,2A2.00006,2.00006,0,0,0,10,11Z"/>
			</svg>
		);
	}
}

export default TagsIcon;
